<template>
  <div class="versions">
    <div class="btn-box">
      <el-button class="add-btn" @click="add" icon="el-icon-plus"
        >上传版本信息</el-button
      >
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="name" label="app名字"></el-table-column>
        <el-table-column prop="versionNo" label="版本号"> </el-table-column>
        <el-table-column prop="systemType_dictText" label="系统类型">
          <!-- <template slot-scope="{ row }">
            {{
              getDictDataLabel(DICT_TYPE.SYSTEM_TYPE, Number(row.systemType))
            }}
          </template> -->
        </el-table-column>
        <el-table-column prop="updateType_dictText" label="更新类型">
          <!-- <template slot-scope="{ row }">
            {{
              getDictDataLabel(DICT_TYPE.UPDATE_TYPE, Number(row.updateType))
            }}
          </template> -->
        </el-table-column>
        <el-table-column prop="manufacturer_dictText" label="设备品牌">
          <!-- <template slot-scope="{ row }">
            {{
              getDictDataLabel(DICT_TYPE.SYSTEM_TYPE, Number(row.systemType))
            }}
          </template> -->
        </el-table-column>
        <el-table-column prop="updateDescription" label="更新描述">
          <template slot-scope="{ row }">
            <el-button
              @click="checkDescription(row.updateDescription)"
              class="textBlue-btn"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="url" label="下载链接">
          <template slot-scope="{ row }">
            <!-- <p>{{ row.url }}</p> -->
            <el-button @click="copyUrl(row.url)" class="textBlue-btn"
              >复制</el-button
            >
            <el-button @click="downloadUrl(row.url)" class="textBlue-btn"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="url" label="操作">
          <template slot-scope="{ row }">
            <el-button @click="edit(row)" class="textOrange-btn"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 查看描述 -->
    <el-dialog
      :visible.sync="descriptionVisible"
      title="版本描述"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="30%"
    >
      <div slot="title" class="title">
        <p>版本描述</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        {{ description }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVersionsList } from "@/api/login";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        systemType: "",
        updateType: "",
      },
      tableData: [],
      total: 0, //总数
      descriptionVisible: false,
      description: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取协议列表
    async init() {
      const res = await getVersionsList(this.queryParams);
      console.log(res);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查看内容
    checkDescription(description) {
      this.description = description;
      this.descriptionVisible = true;
    },
    handleClose() {
      this.descriptionVisible = false;
    },
    async copyUrl(url) {
      const textToCopy = url;
      await navigator.clipboard.writeText(textToCopy);
      this.$message.success("复制成功");
    },
    downloadUrl(url) {
      window.open(url);
    },
    // 添加
    add() {
      this.$router.push({
        path: "/newversions",
        query: {
          type: "add",
        },
      });
    },
    // 编辑
    edit(row) {
      localStorage.setItem("versionInfo", JSON.stringify(row));
      this.$router.push({
        path: "/newversions",
        query: {
          type: "edit",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.versions {
  position: relative;
  .btn-box {
    position: absolute;
    top: -88px;
    right: 0;
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        max-height: 500px;
        overflow-y: scroll;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  .textOrange-btn {
    padding: 0 5px;
  }
}
</style>
